module.exports = __webpack_public_path__ + "img/icon-map.f3c73070.svg";